module.exports = "/_next/static/images/Twilio-485c9e2334338d74a6744b4a0d4dfae7.png";